<<template>
<section class="vinculacionAcademica">
    <p class="titleColorSystem">Certificaciones</p>
    <div class="sci-cer-content">
      <table class="sci-cer-table">
        <thead class="sci-cer-thead">
          <div class="sci-cer-busqueda">
          </div>
          <v-flex d-flex xs12 sm12 md5>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar nombre, unidad que la ofrece, organismo que la avala..."
              clearable
              flat
              @click="limpiarCampos"
              :hint="`Se Encontraron
                ${infCount ? infCount : 0}
                Resultados`"
              @change="
                getCertificaciones(page, search),
                getCertificacionesExcel(page, search)
              "
            ></v-text-field>
          </v-flex>
          <span class="sci-cer-count">
            <vue-excel-xlsx
              v-if="certificaciones.data.length > 0"
              class="sci-cer-excel"
              :data="certificacionesExcelData"
              :columns="columns"
              :filename="'certificaciones'"
              :sheetname="'certificacion'"
            >
              Descargar resultados
            </vue-excel-xlsx>
          </span>
          <tr class="sci-cer-tr1">
            <td>Institución</td>
            <td>Nombre de la certificación</td>
            <td>Unidad o área que la ofrece</td>
            <td>Organismo que la avala</td>
            <td></td>
			<td>Contacto</td>
          </tr>
        </thead>
        <span v-if="!infCount">
          <h3 class="font-weight-thin mb-3">SIN INFORMACIÓN</h3>
          <h4 class="subheading">POR FAVOR REALICE UNA BÚSQUEDA</h4>
        </span>
        <tbody v-else id="tbody" class="sci-cer-tbody" d-flex xs12 sm12 md5>
          <tr
            v-for="(certificaciones, index) in certificaciones.data"
            :key="index"
          >
            <span class="sci-cer-tr2">
              <td class="sci-cer-tr2-td">
                {{ certificaciones.institucion_academica ? certificaciones.institucion_academica.nombre : "" }}
              </td>
              <td class="sci-cer-tr2-td">
                {{ certificaciones.nombre ? certificaciones.nombre : "" }}
              </td>
              <td class="sci-cer-tr2-td">
                {{ certificaciones.organismo_que_avala ? certificaciones.organismo_que_avala : "" }}
              </td>
              <td class="sci-cer-tr2-td">
                {{ certificaciones.unidad_que_ofrece ? certificaciones.unidad_que_ofrece : "" }}
              </td>
              <td class="sci-cer-tr2-td">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" flat @click.stop="$set(dialogNote, certificaciones.id, true)">
                    Ver más
                    </v-btn>
                  </template>
                  <span>Ver más información</span>
                </v-tooltip>
                <v-dialog v-model="dialogNote[certificaciones.id]" scrollable lazy max-width="600" max-height="600" :key="certificaciones.id">
                  <v-card>
                    <v-card-title class="justify-content-center">
                      <span class="grey--text">{{certificaciones.institucion_academica? certificaciones.institucion_academica.nombre : ""}}</span>
                      <span class="text-primary headline">{{certificaciones.nombre}}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-flex>
                        <v-text-field
                          readonly
                          label="Duración"
                          v-model="certificaciones.duracion_de_certificacion"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Tiempo de la implementación"
                          readonly
                          v-model="certificaciones.tiempo_de_implementacion"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Costo"
                          readonly
                          v-model="certificaciones.costo"
                        ></v-text-field>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click.stop="$set(dialogNote, certificaciones.id, false)">Cerrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td class="sci-cer-tr2-td">
				  <v-tooltip bottom>
				  	<SentMailToAcademicas slot="activator" v-bind:institucionAcademica="certificaciones.institucion_academica"></SentMailToAcademicas>
					<span>Click para enviar correo</span>
				  </v-tooltip>
			  </td>
            </span>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="certificaciones"
            @pagination-change-page="getCertificaciones"
          ></pagination>
        </div>
      </table>
    </div>
    <LoadingComponent :loading="dialogLoading"></LoadingComponent>
  </section>
</template>

<script>
import axios from "axios";
import SentMailToAcademicas from './SentMailToAcademicas.vue';
import LoadingComponent from '../../components/LoadingDialog.vue';
export default {
  props: ["urlApi"],
    components:{
    SentMailToAcademicas,
    LoadingComponent
	},
  data() {
    return {
		page: 1,
        dialogLoading: false,
        dialogNote: {},
      	columns: [
		{ label: "Institución", field: "institucion_nombre"},
		{ label: "Nombre de la certificación", field: "nombre" },
        { label: "Organismo que la avala", field: "organismo_que_avala" },
        { label: "Unidad que la ofrece", field: "unidad_que_ofrece" },
        { label: "Duración", field: "duracion" },
        { label: "Tiempo de la implementación", field: "tiempo_implementacion" },
        { label: "Costo", field: "costo" },
      ],
      search: null,
      load: 1,
      certificaciones: {
        current_page: 1,
        data: {
          certificaciones: [],
        },
      },
      certificacionesExcel: {
	  },
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  computed: {
    infCount() {
      return this.certificaciones.total;
    },
	certificacionesExcelData() {
		let certificaciones= []
        if(this.certificacionesExcel.data){
		this.certificacionesExcel.data.forEach(element => {
			let certificacion = {
				institucion_nombre: element.institucion_academica.nombre,
				nombre_certificacion: element.nombre,
				organismo_que_avala: element.organismo_que_avala,
				unidad_que_ofrece: element.unidad_que_ofrece,
        duracion: element.duracion_de_certificacion,
        tiempo_implementacion: element.tiempo_de_implementacion,
        costo: element.costo
			}
			certificaciones.push(certificacion);
		});
		return certificaciones;
        }
	}
  },
  methods: {
    getCertificaciones: function (page = 1) {
      this.dialogLoading = true;
      var url = process.env.VUE_APP_API_URL + `/api/certificacion-ofrecida?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.certificaciones = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => this.dialogLoading = false);
    },
    getCertificacionesExcel: function (page = 1) {
      var url = process.env.VUE_APP_API_URL + `/api/certificacion-ofrecida?perPage=200&page=1&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.certificacionesExcel = response.data;
        })
        .catch((error) => console.log("Error ", error));
    },
    getCurrentElement: function (ElementId) {
      this.CurrentElement = this.certificaciones.data.find((item) => {
        return item.id == ElementId;
      });
    },
    addActiveClass: function () {
      let td = document.getElementsByClassName("sci-cer-tr2");
      for (var i = 0; i < td.length; i++) {
        td[i].addEventListener("click", function () {
          var current = document.getElementsByClassName("active");
          current[0].className = current[0].className.replace(" active", "");
          this.className += " active";
        });
      }
    },
    limpiarCampos() {
      this.search = "";
    },
  },
};
</script>

<style>
.sci-cer-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-cer-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-cer-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-cer-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-cer-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-cer-content {
  display: grid;
  grid-template-areas:
    "sci-cer-table sci-cer-show"
    "sci-cer-table sci-cer-show"
    "sci-cer-table sci-cer-show"
    "sci-cer-table sci-cer-show"
    "sci-cer-table sci-cer-show"
    ". sci-cer-show"
    ". sci-cer-show"
    ". sci-cer-show"
    ". sci-cer-show"
    ". sci-cer-show"
    ". sci-cer-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-cer-table {
  display: grid;
  grid-area: sci-cer-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-cer-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-cer-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-cer-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-cer-busqueda input:focus {
  outline: 0;
}
.sci-cer-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-cer-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-cer-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-cer-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-cer-excel {
  font-weight: bold;
  color: #0d47a1;
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0rem 0;
  border-radius: 5px;
  display: grid;
  width: 100%;
}
.sci-cer-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-cer-tr1 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr 1fr;
  text-transform: uppercase;
  text-align: center;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-cer-tbody {
  text-align: left;
}
.sci-cer-tr2 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr 1fr;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
}
.sci-cer-tr2-td {
  cursor: pointer;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active {
  background-color: rgba(0, 132, 255, 1);
  color: rgba(255, 196, 0, 1);
  font-weight: bold;
}
.sci-cer-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-cer-show {
  width: 96%;
  margin-top: 50px;
  display: grid;
  grid-area: sci-cer-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
  text-transform: uppercase;
}
.sci-cer-show2 {
  height: 340px;
}
.sci-cer-nameInf {
  text-align: center;
  width: 90%;
  max-height: 100px;
  margin: 2% auto 0;
  color: rgba(0, 132, 255, 1);
  font-size: 1.3em;
  padding: 5px 0 0 0;
}
.sci-cer-cont-info {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.sci-cer-inf1-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-cer-info1 {
  display: grid;
  width: 100%;
  margin: 0 auto;
}
.sci-cer-inf1-container {
  padding: 0;
}
.sci-inf-info1 div,
.sci-inf-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-inf-info1-p1,
.sci-inf-info1-p2,
.sci-inf-info1-p3,
.sci-inf-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-inf-info1-3 {
  padding: 0 0 5px 0;
}
.sci-inf-info2 {
  display: grid;
  color: #000;
}
.sci-inf-info2-p1,
.sci-inf-info2-p2,
.sci-inf-info2-p3,
.sci-inf-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
@media only screen and (max-width: 1400px) and (min-width: 100px) {
  .sci-cer-tr1 {
    min-width: 17%;
  }
}
@media only screen and (max-width: 1000px) and (min-width: 100px) {
  .sci-cer-tr1 {
    font-size: 0.75em;
  }
}
@media only screen and (max-width: 850px) and (min-width: 100px) {
  
}
@media only screen and (max-width: 600px) and (min-width: 50px) {
  .sci-cer-tr1 {
    font-size: 0.8em;
  }
}
@media only screen and (max-width: 500px) and (min-width: 50px) {
  .sci-cer-tr1 {
    font-size: 0.85rem;
    margin-top: 1.5%;
  }
  
}
</style>